import { Row, Col, Badge, Table, Card } from "reactstrap";

const SummaryField = ({ children, title, data }) => {
  return (
    <div className="mb-1">
      <div className="d-inline  pr-2">
        <small className="font-weight-bold">{title}:</small>
      </div>
      <div className="d-inline">
        <small>{data}</small>
        {children}
      </div>
    </div>
  );
};

export default function SummaryCard({ field }) {
  return (
    <Card className="p-2 border-none" style={{ background: "transparent" }}>
      <Row>
        <Col xs="12" md="6">
          <SummaryField title="Name" data={field.Name} />
          <SummaryField title="API Name" data={field.APIName} />
          <SummaryField
            title="Description"
            data={field.Description ? field.Description : "--"}
          />
          <SummaryField title="Data Type" data={field.FieldType} />
          <SummaryField title="Required" data={field.Required ? "Yes" : "No"} />
          <SummaryField
            title="Unique Values"
            data={field.Unique ? "Yes" : "No"}
          />
        </Col>
        <Col xs="12" md="6">
          <SummaryField
            title="Readable Name Template"
            data={field.DisplayField ? field.DisplayField : "--"}
          />
          <SummaryField
            title="Default Value"
            data={
              field.DefaultValue !== undefined && field.DefaultValue !== null
                ? field.DefaultValue.toString()
                : "--"
            }
          />
          <SummaryField
            title="Selectable Options"
            data={!field.SourcesList ? "--" : ""}
          >
            {field.SourcesList && typeof field.SourcesList == "string" ? (
              <small>
                <Badge
                  color="secondary"
                  style={{
                    position: "relative",
                    top: "-1px",
                  }}
                >
                  Reference
                </Badge>{" "}
                {field.SourcesList}
              </small>
            ) : (
              ""
            )}
            {field.SourcesList && typeof field.SourcesList != "string" ? (
              <>
                <Table className="table table-sm border">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {field.SourcesList.map((source, i) => (
                      <tr key={i}>
                        <td>{source.Name}</td>
                        <td>{source.Value}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </>
            ) : (
              ""
            )}
          </SummaryField>
          <SummaryField
            title="Read Only"
            data={field?.ReadOnly ? "Yes" : "No"}
          />
        </Col>
      </Row>
    </Card>
  );
}
